import http from "./httpService";

const apiEndpoint = "/time_zone";

export function getTimeZone() {
  return http.get(apiEndpoint + '/list');
}


